import React from 'react'

export default function TipoCuenta() {
  return (
    <div>
      
    </div>

  )
}
